export class RegisterCredentials {
    public email: string;
    public firstName: string;
    public lastName: string;
    public personnummer: string;
    public password: string;
    public confirmPassword: string;
    public addressCountry: string;
    public primaryContactLanguage: number;

    /*constructor(inEmail: string, inPersonnummer: string, inPassword: string, inConfirmPassword: string) {
        this.email = inEmail;
        this.personnummer = inPersonnummer;
        this.password = inPassword;
        this.confirmPassword = inConfirmPassword;
    }*/

    constructor() {
        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.personnummer = '';
        this.password = '';
        this.confirmPassword = '';
        this.addressCountry = '';
    }
}
